import { Tag } from '@/common'
import { useTranslation } from 'react-i18next'

export default function CnCodeTag({ cnCode }: { cnCode: string }) {
  const { t } = useTranslation()
  return <Tag label={cnCode} className="font-mono" title={t(`goods:${cnCode}`)} />
}
